import React, { useState, useEffect } from "react";
import { GoogleLogin } from '@react-oauth/google';
import { useNavigate } from "react-router-dom";
import BodyContainer from "../components/BodyContainer";
import BottomContainer from "../components/BottomContainer";
import Footer from '../components/Footer';
import FooterLinks from '../components/FooterLinks';
import { Helmet } from "react-helmet-async";
import bannerImage from '../assets/banner4.png';
import Banner from '../components/Banner';
import "../About.css";
const API_URL = process.env.REACT_APP_API_BASE_URL;
const IP_URL = process.env.REACT_APP_API_IP_URL;

function Login() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  async function logGoogleLogin(userEmail) {
  try {
    await fetch(IP_URL, {  // Use your API Gateway /google-login route
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userEmail }),
    });
    console.log("Google login logged!");
  } catch (err) {
    console.error("Failed to log Google login:", err);
  }
}

function parseJwt(token) {
  try {
    const base64Url = token.split('.')[1]; // middle part of JWT
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (err) {
    console.error("Failed to parse JWT:", err);
    return null;
  }
}



  // Handle successful login
const handleSuccess = async (response) => {
  console.log("Google Login Success:", response);

  const userData = {
    idToken: response.credential,
  };

  // Extract email from JWT
  const decoded = parseJwt(response.credential);
  const userEmail = decoded?.email || "unknown@example.com";

  // Log login event
  logGoogleLogin(userEmail);

  try {
    const res = await fetch(`${API_URL}/api/auth/google`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(userData),
      mode: "cors",
    });

    const data = await res.json();
    localStorage.setItem("user", JSON.stringify(data.user));
    setUser(data.user);
    navigate("/profile");
  } catch (error) {
    console.error("Error during login:", error);
  }
  
};



  if (user) {
    // If user is logged in, redirect to profile page
    navigate("/profile");
    return null;
  }

  return (
    <><>
      <Helmet>
        <title>PharmPrepPro - Login</title>
      </Helmet>

      <BottomContainer>
        <Banner
          height="300px"
          
          image={bannerImage} // Pass image dynamically
        />

        <BodyContainer>
          <h1 className="white-text">Login</h1>
          <p className="white-text">Click the button below to log in using Google.</p>

          {/* Google OAuth Login Button */}
          <GoogleLogin
            onSuccess={handleSuccess}
            //onError={handleFailure} 
            />
        </BodyContainer>


      </BottomContainer>
    </><FooterLinks /><Footer /></>
  );
}

export default Login;
